import { Tooltip, Icon } from '@chakra-ui/react';

export default function LaunchdeckTooltip({hoverMessage, closeDelay, placement, color, w, sx}) {		
  
  if (hoverMessage) {
    return (
      <Tooltip flex='1 1 0' label={hoverMessage} maxWidth={w && w} sx={sx && sx}ml='1em' fontSize='0.8em' placement={placement ? placement : "right"} closeDelay={closeDelay && closeDelay}>
        <Icon name="info" color={color && color}/>
      </Tooltip>
		)
  } else return null
}


// Repurpose as a tool tip label